export var MODAL_TAB_INDEX_BASE = 1000;
//# sourceMappingURL=tabIndexes.js.map